import React from 'react';
import PageAccess from '@gp/components/PageAccess';
import { PERMISSION_APPLY_URL } from '@gp/constants/const';

const description = (
  <div>
    To request access to GPOP or to upgrade your current permissions, including access to sensitive data, please{' '}
    <a target="_blank" href={PERMISSION_APPLY_URL} rel="noreferrer">
      fill out the GPOP Access Application Form
    </a>
    . <br />
    Your application will be processed within one week, and you will receive a notification upon any change to your
    access rights.
    <br />
    If you have any questions, please contact the administrators <strong>jinglichen</strong> or <strong>judymao</strong>{' '}
    for assistance.
  </div>
);

export default function CommonNoAuthPageAccess() {
  return (
    <PageAccess isAccess={false} description={description}>
      <span></span>
    </PageAccess>
  );
}
